<template lang="html">
  <div id="mobile-recharge-page">

    <b-form @submit="onSubmit">

      <section class="container content-section" v-if="this.$route.params.step != 'finalizado'">
        <div class="row">
          <div class="col-12 col-title-s1">
            <h3 class="title">Compra de saldo y megas</h3>
          </div>

          <div class="col-12 col-info">
            <p class="text-center">
              Ingresa el número, elige si deseas recargar compra de paquetes de datos y sigue los pasos hasta completar tu compra.
            </p>

            <h6 class="mt-4 mb-2 text-center subtitles-s2"><div class="circle-num"><i>1</i></div> Ingresa tus datos</h6>

            <div class="row justify-content-center">

              <div class="col-lg-6 col-xl-5">
                <div class="row">

                  <!-- Paso 1 -->
                  <!-- Esta opción se supone que esté solo cuando el usuario esté conectado a su cuenta y por lo tanto tengamos los datos, entre ellos su numero de teléfono ligado -->
                  <div class="col-12 mt-2 mb-2">
                    <b-form-checkbox
                      v-model="myNumber"
                      name="checkbox--mynumber"
                      :value="true"
                      :unchecked-value="false">
                      <span class="f-w-600">Recargar a mi número de teléfono.</span>
                    </b-form-checkbox>
                    <hr class="mt-2" />
                  </div>
                  <!-- !! -->

                  <b-form-group class="col-12 custom-f-group" label="Mi Número (10 dígitos):" v-if="myNumber">
                    <b-form-input
                      type="text"
                      :value="form.tel"
                      disabled
                    ></b-form-input>
                  </b-form-group>


                  <div class="row mx-0" v-else>
                    <b-form-group class="col-12 custom-f-group" label="Número telefónico (10 dígitos):">
                      <b-form-input
                        v-model="form.tel"
                        type="text"
                        :minlength="10"
                        :maxlength="10"
                        required
                        placeholder=""
                        @keypress="$root.isNumber($event)" @paste="$root.noPaste"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group class="col-12 custom-f-group mb-0" label="Confirmar el número:">
                      <b-form-input
                        v-model="form.tel2"
                        :minlength="10"
                        :maxlength="10"
                        type="text"
                        required
                        placeholder=""
                        @keypress="$root.isNumber($event)" @paste="$root.noPaste"
                      ></b-form-input>
                    </b-form-group>

                    <div class="col-12 mb-3">
                      <p v-if="form.tel != form.tel2"><small class="text-danger f-w-600">Los números deben coincidir</small></p>
                      <p v-if="form.tel.length <= 9 || form.tel2.length <= 9"><small class="text-danger f-w-600">Los números deben tener 10 dígitos.</small></p>
                    </div>
                  </div>

                  <b-form-group class="col-12 custom-f-group types-r-group" label="Selecciona el tipo de paquete" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      v-model="form.tipo" :aria-describedby="ariaDescribedby" name="radio-tipo" class="box-radios">
                      <b-form-radio value="movil">
                        <div class="radio-content">
                          <p class="p-icon">
                            <i class="fas fa-mobile-alt"></i>
                          </p>
                          <h6>Movilidad</h6>
                        </div>
                      </b-form-radio>
                      <b-form-radio value="mifi">
                        <div class="radio-content">
                          <p class="p-icon">
                            <i class="far fa-router"></i>
                          </p>
                          <h6>MiFi</h6>
                        </div>
                      </b-form-radio>
                      <b-form-radio value="casa">
                        <div class="radio-content">
                          <p class="p-icon">
                            <i class="far fa-home-alt"></i>
                          </p>
                          <h6>Casa</h6>
                        </div>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <b-form-group class="col-12 custom-f-group packs-group" label="Selecciona un paquete:" v-if="form.tipo">
                    <div class="inside" @click="$refs['modal-packs'].show()">
                      <b-form-select v-model="form.paquete">
                        <b-form-select-option :value="''">Seleccione un paquete</b-form-select-option>
                        <b-form-select-option :value="pa.id" v-for="(pa, paSRInx) in selectedPlan" :key="'paSRInx-'+paSRInx">Paquete {{ pa.planName }} - {{ pa.gbs }} x {{ pa.days }}, {{ pa.price }}</b-form-select-option>
                      </b-form-select>
                    </div>
                  </b-form-group>

                  <div class="col-12" v-if="step == 1">
                    <p class="text-center text-danger f-w-600">Complete el formulario con los 10 digitos de su número telefónico y seleccione un paquete.</p>
                  </div>
                  <!-- fin - paso 1 -->

                  <!-- Paso 2 -->
                  <div class="row mx-0" v-if="step > 1">
                    <div class="col-12 text-center">
                      <h6 class="mt-3 mb-2 subtitles-s2"><div class="circle-num"><i>2</i></div> Pago</h6>
                      <p class="mb-3">
                        <img style="height: 30px;" src="public/images/pages/mobile-recharge/payments.svg">
                      </p>
                    </div>

                    <b-form-group class="col-12 custom-f-group" label="Selecciona la forma de pago:">
                      <b-form-select required v-model="form.formapago">
                        <b-form-select-option :value="null">Elige una opción</b-form-select-option>
                        <b-form-select-option value="1">Crédito o débito</b-form-select-option>
                        <b-form-select-option value="2">Deposito en Banco</b-form-select-option>
                        <b-form-select-option value="3">Deposito en Oxxo</b-form-select-option>
                      </b-form-select>
                    </b-form-group>

                    <!-- Crédito o débito -->
                    <div class="col-12" v-if="form.formapago == 1">
                      <div class="row">
                        <div class="col-12 text-center">
                          <!-- <hr /> -->
                          <h6 class="mt-3 mb-2 subtitles-s2">Crédito o débito</h6>
                        </div>

                        <b-form-group class="col-12 custom-f-group" label="Número de tarjeta:">
                          <b-form-input
                            v-model="form.tarjeta"
                            type="text"
                            :maxlength="16"
                            required
                            placeholder=""
                            @keypress="$root.isNumber($event)" @paste="$root.noPaste"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-12 col-sm-8 custom-f-group" label="Fecha de vencimiento:">
                          <div class="row">
                            <div class="col-6 pr-1">
                              <b-form-select required v-model="form.mes">
                                <b-form-select-option :value="null">Mes</b-form-select-option>
                                <b-form-select-option v-for="(x, mInx) in 12" :key="'mInx-'+mInx" :value="mInx + 1">{{ mInx + 1 }}</b-form-select-option>
                              </b-form-select>
                            </div>

                            <div class="col-6 pl-1">
                              <b-form-select required v-model="form.anio">
                                <b-form-select-option :value="null">Año</b-form-select-option>
                                <b-form-select-option v-for="(x, yInx) in 10" :key="'yInx-'+yInx" :value="currentYear + yInx">{{ currentYear + yInx }}</b-form-select-option>
                              </b-form-select>
                            </div>
                          </div>
                        </b-form-group>

                        <b-form-group class="col-6 col-sm-4 pr-1 pr-sm-3 custom-f-group" label="CVV:">
                          <b-form-input
                            v-model="form.cvv"
                            type="text"
                            :minlength="3"
                            :maxlength="3"
                            required
                            placeholder=""
                            @keypress="$root.isNumber($event)" @paste="$root.noPaste"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-12 custom-f-group" label="Correo electrónico:">
                          <b-form-input
                            v-model="form.email"
                            type="email"
                            :maxlength="45"
                            required
                            placeholder=""
                          ></b-form-input>
                        </b-form-group>

                        <div class="col-12 mt-1 text-center">
                          <b-button type="submit" class="btn-send btn-s2">Pagar</b-button>
                        </div>
                      </div>
                    </div>
                    <!--  -->

                    <!-- Deposito en Banco -->
                    <div class="col-12" v-if="form.formapago == 2">
                      <div class="row">
                        <div class="col-12 text-center">
                          <!-- <hr /> -->
                          <h6 class="mt-3 mb-2 subtitles-s2">Deposito en Banco</h6>
                        </div>

                        <div class="col-12 mb-3">
                          <h6><span>Banco: </span> <strong>Santander</strong></h6>
                          <h6 class="mt-1"><span>Número de referencia: </span> <strong>26840397160492</strong></h6>
                          <h6 class="mt-1"><span>Cantidad a pagar: </span> <strong>$150.00 MXN</strong></h6>
                        </div>

                        <b-form-group class="col-12 custom-f-group" label="Correo electrónico:">
                          <b-form-input
                            v-model="form.email"
                            type="email"
                            :maxlength="45"
                            required
                            placeholder=""
                          ></b-form-input>
                        </b-form-group>

                        <div class="col-12 mt-1 text-center">
                          <b-button type="submit" class="btn-send btn-s2">Enviar datos por correo</b-button>
                        </div>
                      </div>
                    </div>
                    <!--  -->

                    <!-- Deposito en Oxxo -->
                    <div class="col-12" v-if="form.formapago == 3">
                      <div class="row">
                        <div class="col-12 text-center">
                          <!-- <hr /> -->
                          <h6 class="mt-3 mb-2 subtitles-s2">Deposito en Oxxo</h6>
                        </div>

                        <div class="col-12 mb-3">
                          <h6><span>Cuenta: </span> <strong>126846024985310</strong></h6>
                          <h6 class="mt-1"><span>Número de referencia: </span> <strong>26840397160492</strong></h6>
                          <h6 class="mt-1"><span>Cantidad a pagar: </span> <strong>$150.00 MXN</strong></h6>
                        </div>

                        <b-form-group class="col-12 custom-f-group" label="Correo electrónico:">
                          <b-form-input
                            v-model="form.email"
                            type="email"
                            :maxlength="45"
                            required
                            placeholder=""
                          ></b-form-input>
                        </b-form-group>

                        <div class="col-12 mt-1 text-center">
                          <b-button type="submit" class="btn-send btn-s2">Enviar datos por correo</b-button>
                        </div>
                      </div>
                    </div>
                    <!--  -->

                  </div>
                  <!-- fin - paso 2 -->

                </div>
              </div>

            </div>
          </div>

          <div class="col-12 mt-5 col-info">
            <hr />
            <h3 class="mb-2 text-center subtitle-s1">Compra de saldo y paquetes de datos</h3>

            <p class="text-justify">
              Ahora puedes realizar la compra de saldo y paquetes de datos en nuestra plataforma, en tres sencillos pasos y con garantía de pago seguro con tarjetas de crédito o débito (Visa, MasterCard y American Express).<br />
              <br />
              El mundo se está transformando rápida y radicalmente; la forma de conectarnos entre personas está evolucionando y las formas de trabajar se están diversificando. Hoy más que nunca es necesario contar con internet móvil de alta velocidad y con la mejor cobertura, para tener acceso a nuevas y mejoradas tecnologías.<br />
              <br />
              Renovamos nuestro sitio para que puedas recargar saldo y comprar megas de forma más eficiente, para que nada te detenga y puedas trabajar a distancia, asistir a eventos virtuales, compartir en tus Redes Sociales y te mantengas informado de las últimas noticias.
            </p>
          </div>
        </div>
      </section>

      <!-- Finalizado con éxito -->
      <section class="container finished-section" v-if="this.$route.params.step == 'finalizado'">
        <div class="row">
          <div class="col-lg-7">
            <success-checkmark2-component></success-checkmark2-component>

            <h2 class="mb-2 title">Paquete seleccionado con éxito.</h2>

            <p class="f-w-600">
              Se envío un mensaje a su correo electrónico con sus datos de pago.<br />
              En caso de hacer su pago en Banco u Oxxo, el pago puede verse reflejado en aproximadamente 24 hrs.
            </p>

            <p class="mt-4">
              <router-link class="f-w-600" to="/"><i class="fas fa-home-lg-alt"></i> Regresar al Inicio</router-link>
            </p>
          </div>
        </div>
      </section>
      <!--  -->

      <!-- Modal -->
      <b-modal modal-class="modal-packs-s1" ref="modal-packs" @shown="showingModal" @hidden="loadedModal = false" hide-footer no-close-on-backdrop no-close-on-esc centered>
        <loading-component v-if="!loadedModal" :height="'400px'"></loading-component>

        <div class="row mx-0" v-else>
          <div class="col-12 px-0 col-text">
            <h5 class="mt-1 mb-2 text-center title">Selecciona tu paquete
              <span class="pack" v-if="form.tipo == 'movil'"><i class="fas fa-mobile-alt"></i> Movilidad</span>
              <span class="pack" v-if="form.tipo == 'mifi'"><i class="far fa-router"></i> Mifi</span>
              <span class="pack" v-if="form.tipo == 'casa'"><i class="far fa-home-alt"></i> Casa</span>
            </h5>
          </div>

          <div class="col-12 px-0">
            <swiper class="swiper swiper-packs-s1" v-bind:class="{ 'sw-pack-s1' : form.tipo == 'movil' }" :options="swiperOption">
              <swiper-slide v-for="(pa, paInx) in selectedPlan" :key="'paInx-'+paInx">
                <div class="col-12 box-pack-s1">
                  <div class="col-12 col-image" v-if="pa.img">
                    <img :src="pa.img" alt="">
                  </div>

                  <div class="col col-l" v-bind:class="{ 'c-1': pa.nChars == 1, 'c-2': pa.nChars == 2, 'c-3': pa.nChars == 3, }">
                    <h5 class="days" v-html="pa.days"></h5>
                    <h5 class="gbs"><i class="i-speed"></i> <span>{{ pa.gbs }}</span></h5>
                    <h5 class="hotspot" v-if="pa.hotspot"><i class="i-hotspot"></i> <span>Hotspot</span></h5>
                    <h5 class="monthly" v-if="pa.monthly"><i class="i-monthly"></i> <span>Por Mes</span></h5>
                  </div>

                  <div class="col col-r">
                    <h6 class="s-name">{{ pa.planName }}</h6>

                    <div class="descr" v-html="pa.descr"></div>

                    <div class="box-price">
                      <div class="price" v-bind:class="{ 'monthly' : pa.monthly }">
                        <div>
                          <div class="txt-1">{{ pa.price }}</div>
                          <div class="txt-2" v-if="pa.monthly">Por Mes</div>
                        </div>
                      </div>
                      <a class="t-250 btn-rent price" @click="selectPack(pa.id)"><span>Contratar</span></a>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </b-modal>
      <!--  -->

    </b-form>
  </div>
</template>

<script>
import loadingComponent from '../shared/loading.vue';
import successCheckmark2Component from '../shared/success-checkmark-component-2.vue';
export default {
  data(){
    return{
      currentYear: 0,
      loadedModal: false,
      step: 1,

      myNumber: false,
      fakeNumber: 3311224488, // NOTA: Este numero debe ser un string

      form: {
        tel: '',
        tel2: '',
        tipo: '',
        paquete: '',
        tarjeta: null,
        mes: null,
        anio: null,
      },

      selectedPlan: [],

      // planA: [
      //   {
      //     id: 1,
      //     img: 'public/images/pages/home/cometa.png',
      //     nChars: 1,
      //     days: '3 días',
      //     gbs: '4 GB',
      //     hotspot: false,
      //     planName: 'COMETA',
      //     price: '$33.00 MXN',
      //     descr: `<p>2000 MB NORMAL<br />2000 MB VEL REDUCIDA<br />250 MINUTOS Y 125 SMS</p>`,
      //   },
      //   {
      //     id: 2,
      //     img: 'public/images/pages/home/space.png',
      //     nChars: 1,
      //     days: '7 días',
      //     gbs: '10 GB',
      //     hotspot: false,
      //     planName: 'SPACE',
      //     price: '$55.00 MXN',
      //     descr: `<p>5000 MB NORMAL<br />5000 MB VELOCIDAD REDUCIDA<br />500 MINUTOS Y 250 SMS</p>`,
      //   },
      //   {
      //     id: 3,
      //     img: 'public/images/pages/home/universe.png',
      //     nChars: 2,
      //     days: '15 días',
      //     gbs: '20 GB',
      //     hotspot: false,
      //     planName: 'UNIVERSE',
      //     price: '$110.00 MXN',
      //     descr: `<p>10,000 MB NORMAL<br />10,000 MB VELOCIDAD REDUCIDA<br />1000 MINUTOS Y 500 SMS</p>`,
      //   },
      //   {
      //     id: 4,
      //     img: 'public/images/pages/home/estelar.png',
      //     nChars: 2,
      //     days: '30 días',
      //     gbs: '40 GB',
      //     hotspot: false,
      //     planName: 'ESTELAR',
      //     price: '$220.00 MXN',
      //     descr: `<p>20,000 MB NORMAL<br />20,000 MB VELOCIDAD REDUCIDA<br />1500 MINUTOS Y 1000 SMS</p>`,
      //   },
      //   {
      //     id: 5,
      //     img: 'public/images/pages/home/bigbang.png',
      //     nChars: 2,
      //     days: '30 días',
      //     gbs: '40 GB',
      //     hotspot: true,
      //     planName: 'BIGBANG',
      //     price: '$300.00 MXN',
      //     descr: `<p>20,000 MB NORMAL<br />20,000 MB VELOCIDAD REDUCIDA<br />1500 MINUTOS Y 1000 SMS<br /><strong>+ HOTSPOT</strong></p>`,
      //   },
      //   {
      //     id: 6,
      //     img: 'public/images/pages/home/infinity.png',
      //     nChars: 2,
      //     days: '30 días',
      //     gbs: '100 GB',
      //     hotspot: true,
      //     planName: 'INFINITY',
      //     price: '$499.00 MXN',
      //     descr: `<p>50,000 MB NORMAL<br />50,000 MB VELOCIDAD REDUCIDA<br />10,000 MINUTOS Y 5000 SMS<br /><strong>+ HOTSPOT</strong></p>`,
      //   },
      //   {
      //     id: 7,
      //     img: 'public/images/pages/home/star.png',
      //     nChars: 2,
      //     days: '30 días',
      //     gbs: '5 GB',
      //     hotspot: true,
      //     planName: 'STAR',
      //     price: '$110.00 MXN',
      //     descr: `<p>5000 MB NORMAL<br />1500 MINUTOS Y 500 SMS<br /><strong>+ HOTSPOT</strong></p>`,
      //   },
      //   {
      //     id: 8,
      //     img: 'public/images/pages/home/sol.png',
      //     nChars: 2,
      //     days: '30 días',
      //     gbs: '8 GB',
      //     hotspot: true,
      //     planName: 'SOL',
      //     price: '$160.00 MXN',
      //     descr: `<p>8000 MB NORMAL<br />1500 MINUTOS Y 500 SMS<br /><strong>+ HOTSPOT</strong></p>`,
      //   },
      // ],

      // == Carousel options ==
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },
      // == ==
    }
  },

  methods: {
    showingModal(){
      setTimeout( ()=>{ this.loadedModal = true; }, 1000); // Se le da 1 seg. para que el carrusel cargue
    },

    selectPack(idx){
      this.form.paquete = idx;
      this.$refs['modal-packs'].hide();
    },

    onSubmit(event) {
      event.preventDefault();

      this.$router.push({ path: '/recargas/finalizado' });
    },
  },

  watch: {
    form: {
      deep: true,

      handler(newValue, oldValue) {
        // Para pasar al paso 2
        if(this.form.tel.toString().length == 10 && this.form.tel2.toString().length == 10 && this.form.paquete.toString() && (this.form.tel == this.form.tel2)){
          this.step = 2;
        }else{
          this.step = 1;
        }
      },
    },

    'form.tipo': function (val, oldVal){
      this.form.paquete = '';
      this.selectedPlan = [];

      if(val == 'movil'){
        this.selectedPlan = this.$root.planMovil;
      }
      if(val == 'mifi'){
        this.selectedPlan = this.$root.planMifi;
      }
      if(val == 'casa'){
        this.selectedPlan = this.$root.planCasa;
      }
    },

    myNumber: function (val, oldVal) {
      if(val){
        this.form.tel = this.fakeNumber;
        this.form.tel2 = this.fakeNumber;
      }else{
        this.form.tel = '';
        this.form.tel2 = '';
      }
    },
  },

  beforeMount(){
    this.currentYear =  new Date().getFullYear();
  },

  components: {
    loadingComponent, successCheckmark2Component
  }
}
</script>
